<template>
    <div>
        <PatientLabelsRep
            v-if="isPatientLabelsRepVisible"
            v-bind:patientCode="this.$route.params.id"
            :visible="isPatientLabelsRepVisible"
            @close="closePatientLabelsRepWindow"
        />

        <MdPasswordDlg
            v-if="showLabPasswordDlg"
            v-bind:Type="'Sign'"
            v-bind:UserId="labPasswordUserId"
            @getModalPassword="onLabPasswordResult($event)"
        />

        <div>
            <template v-for="it in filteredItems">
                <a
                    :key="it.value"
                    :style="Style"
                    @click="triggerClick(it.value, it.text, it.href, $event, it.ReadOnly)"
                    :id="it.value"
                    :class="{
                        isDisabled: itemdisabled || it.ReadOnly,
                        rmActiveItem: !it.ReadOnly && active_element == it.value,
                        'rm-optionssum': PatientSummary.includes(it.value),
                        blinkB4: hasNotification(it.value),
                        'show-before': NoBlueFirst && !PatientSummary.includes(it.value)
                    }"
                >
                    {{ it.text }}
                </a>
            </template>
        </div>
    </div>
</template>

<script>
//import Enum from '@/services/enum.service'
import ShowMessage from '@/components/messages/ShowMessage.js';
import LocalStorage from '@/services/storage.service';
import AppointmentService from '@/services/appointment.service';
import ApptCheckinsService from '@/services/appointmentcheckins.service';
import PatientService from '@/services/patient.service';
import ApiService from '@/services/api.service';
import LabService from '@/services/lab.service';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import { drugOrdersStore } from '@/components/pages/drugordersinbox/drugOrdersStore';
import { patientsPortalStore } from '@/components/pages/patients/portal/patientsPortalStore';

export default {
    name: 'Item',
    mixins: [ShowMessage, DBFunctions],
    props: {
        SortAllOptions: Boolean,
        StyleProp: String,
        NoBlueFirst: Boolean,
        ItemList: Array,
        itemReadOnly: Boolean
    },

    data() {
        return {
            // ItemsList:[],
            isPatientLabelsRepVisible: false,
            Class: '',
            Style: this.StyleProp,
            PatientSummary: [
                'PatientSummary',
                'ClinicalSummary',
                'SchedulerSummary',
                'PPDB_Summary'
            ],
            itemdisabled: false,
            Appointment: {},
            CheckInsAppt: {
                timeCheckIn: ''
            },

            PatientCode: '',
            ItemsListAuthorized: [],
            parameter: {
                UserId: ''
            },
            active_el: '',
            message: this.$t('Layout.displayedScreen'),
            searchOptModel: '',
            AppointmentRouteNames: [
                'treatmentplanbase-Scheduler',
                'appointmentDB-activitiesList',
                'appointmentDB-activitiesAdd',
                'appointmentDB-activitiesEdit',
                'appointmentDB-notes',
                'appointmentDB-Dashboard',
                'appointmentDB-Editor',
                'appointmentDB-PatientInfo',
                'appointmentDB-MdTreatmentplan',
                'MdTreatmentplan-add-Appointment',
                'WyTreatmentplan-add-Appointment',
                'WyTreatmentplan-Appointment',
                'appointmentDB-admissionList',
                'appointmentDB-admission-add',
                'appointmentDB-admission-edit',
                'appointmentDB-allergies',
                'appointmentDB-allergies-details',
                'appointmentDB-allergies-add',
                'appointmentDB-special-precautions',
                'appointmentDB-mars-alerts',
                'appointmentDB-asam',
                'appointmentDB-chartreview',
                'appointmentDB-Ctacts',
                'appointmentDB-Ctacts-details',
                'appointmentDB-Ctacts-add',
                'appointmentDB-diagnosis',
                'appointments-document',
                'appointmentDB-document-detail',
                'appointmentDB-document-add',
                'appointments-insurance',
                'appointments-insurance-details',
                'add-appointments-insurance',
                'appointmentDB-vital-sign',
                'appointmentDB-vital-add',
                'appointmentDB-vital-details',
                'appointmentDB-discharge',
                'appointments-discharge',
                'appointmentDB-transfer',
                'appointments-transfer',
                'appointmentDB-epharmacy',
                'appointmentDB-Medications',
                'Appointments-medications-add',
                'Appointments-medications-details',
                'appointmentDB-Insurance',
                'appointmentDB-alerts',
                'appointmentDB-alert-add',
                'appointmentDB-orders',
                'appointments-test-orders'
            ],
            counts: {
                allergies: 0,
                alerts: 0,
                precautions: 0
            },
            status: {
                hasAllergies: false,
                hasAlerts: false,
                hasSpecialPrecautions: false
            },
            showLabPasswordDlg: false,
            labPasswordUserId: LocalStorage.getUserId(),
            pendingLabAction: null
        };
    },

    methods: {
        closePatientLabelsRepWindow() {
            this.isPatientLabelsRepVisible = false;
        },

        triggerClick: function(eventName, text, href, event, ReadOnly) {
            if (event.target.className != 'isDisabled' && !ReadOnly) {
                this.active_el = eventName;
                // Favorites Actions
                this.checkExistFavorite(href);
                EventBus.$emit('onUpdatedMenu', '');

                // Mapping Functions
                const actionsMap = {
                    PatientSearch: this.GotoPatientList.bind(this),
                    PatientSummary: this.GotoPatientSummary.bind(this),
                    SchedulerSummary: this.GotoSchedulerSummary.bind(this),
                    ClinicalSummary: this.GotoClinicalSummary.bind(this),
                    AppointmentList: () =>
                        this.launchPage(this.$t('MdNotesByAppt.Appointment'), 'appointments', true),
                    SchedulerNotes: this.GotoSchedulerNotes.bind(this),
                    PatientActivities: this.GotoActivities.bind(this),
                    ShowUpAppt: () => this.ShowUpAppt(text),
                    ConfirmAppt: () => this.ConfirmAppt(text),
                    CancelAppt: () => this.OpenAppointmentReason(text),
                    PatientInfo: () => {
                        this.GotoPatientInfo();
                        this.isActive = !this.isActive;
                    },
                    Appointment: () => this.showAppointment(text),
                    GeneralNotes: this.GotoGeneralNotes.bind(this),
                    PatientAsam: () => this.GotoAsam(),
                    PatientContact: () => this.GotoPatientContact(),
                    PatientInsurance: () => this.GotoInsurances(),
                    patientclaimList: () => this.GotoPatientClaim(),
                    PatientDocument: () => this.GotoDocuments(),
                    ClinicalNotes: () =>
                        this.launchPage(this.$t('Shared.ClinicalNotes'), 'Clinical-Notes'),
                    PatientListClinical: this.GotoClinical.bind(this),
                    ClinicalAsam: () => this.launchPage(this.$t('Shared.ASAM'), 'Clinical-Asam'),
                    PatientAllergy: () => this.GotoAllergies(),
                    PatientNotices:() => this.GotoNotices(),
                    PatientSpecialPrecautions: () => this.GotoSpecialPr(),
                    PatientMarsAlerts: () => this.GotoMarsAlerts(),
                    PatientAlerts: () => this.GotoPatientAlerts(),
                    ClinicalVitalSign: () => this.GotoVitalSign(),
                    Medications: () => this.GotoMedications(),
                    Admission: () => this.GotoAdmission(),
                    CHARTREVIEWCLINICAL: () =>
                        this.launchPage(this.$t('ChartReview.CHARTREVIEW'), 'Clinicalchartreview'),
                    ePharmacyPatient: () =>
                        this.launchPage(
                            this.$t('Shared.ePrescribing'),
                            'patientePharmacy',
                            true
                        ),
                    ePharmacyClinical: () => this.GotoePharmacy(),
                    CHARTREVIEWPATIENT: () => this.GotoChartReview(),
                    Transfer: () => this.GotoTransfer(),
                    Discharge: () => this.GotoDischarge(),
                    PatientDischarges: () => this.GotoPatientDischarges(),
                    Diagnosis: () => this.GotoDiagnosis(),
                    DailyNotes: () =>
                        this.launchPage(
                            this.$t('Shared.DailyNotes'),
                            'Clinical-daily-note',
                            true
                        ),
                    LogNotes: () =>
                        this.launchPage(
                            this.$t('Shared.LogNotesTitle'),
                            'Clinical-log-note',
                            true
                        ),
                    ClaimBatchList: this.GotoClaimBatchList.bind(this),
                    DiagnosisClinical: () =>
                        this.launchPage(
                            this.$t('Shared.Diagnosis'),
                            'Clinical-diagnosis',
                            false
                        ),
                    InsuranceClinical: () =>
                        this.launchPage(
                            this.$tc('Insurance.Insurance'),
                            'Clinical-insurance',
                            false
                        ),
                    AllergyClinical: () =>
                        this.launchPage(
                            this.$t('Shared.PatientAllergies'),
                            'Clinical-allergies',
                            false
                        ),
                    'incident-categories': () =>
                        this.launchPage(this.$t('ClinicalNotes.CATEGORIES'), 'incident-categories'),
                    DocumentClinical: () =>
                        this.launchPage(this.$t('employee.Document'), 'Clinical-document', false),
                    ContactClinical: () =>
                        this.launchPage(this.$tc('Contact.Contact'), 'Clinical-cont', false),
                    ADMISSIONINFOCLINICAL: () => this.launchPage(text, 'admission-clinical', true),
                    WYTREATMENTPLAN: () => this.launchPage(text, 'WyTreatmentplan-Clinical', false),
                    MDTREATMENTPLAN: () => this.launchPage(text, 'MdTreatmentplan-Clinical', false),
                    TreatmentPlanClinical: () =>
                        this.launchPage(text, 'treatmentplanbase-Clinical', false),
                    TreatmentPlanScheduler: () =>
                        this.launchPage(text, 'treatmentplanbase-Scheduler', false),
                    SchedulerClinical: () => this.launchPage(text, 'SchedulerClinical', false),
                    SchedulerPatient: () => this.launchPage(text, 'SchedulerPatient', false),
                    Appointments: () => this.launchPage(text, 'patient-appoint', false),
                    ClinicalAppointments: () => this.launchPage(text, 'clinical-appoint', false),
                    AppointmentInsurance: () =>
                        this.launchPage(text, 'appointmentDB-Insurance', false),
                    ClinicalSpecialPrecautions: () =>
                        this.launchPage(
                            this.$t('SpecialPrecautions.PatientSpecialPrecautions'),
                            'Clinical-special-precautions',
                            false
                        ),
                    ClinicalMarsAlerts: () =>
                        this.launchPage(
                            this.$t('Shared.MarsAlerts'),
                            'Clinical-mars-alerts',
                            false
                        ),
                    ClinicalAlerts: () =>
                        this.launchPage(
                            this.$t('Shared.PatientAlerts'),
                            'Clinical-patient-alerts',
                            false
                        ),
                    ClinicalActivities: () =>
                        this.launchPage(
                            this.$t('Shared.Activity'),
                            'Clinical-activities',
                            false
                        ),
                    Orders: () => this.GotoOrders(),
                    TestOrders: () => this.GotoTestOrders(),
                    //To Drug Orders Inbox
                    Itemremoval: () => this.GotoDrugOrderItemRemoval(),
                    Itemsrelocation: () => this.GotoDrugOrderItemRelocation(),

                    Settopending: () => this.DrugOrderOptionsClick('SetToPending'),
                    Settoordered: () => this.DrugOrderOptionsClick('SetToOrdered'),
                    Fillorder: () => this.DrugOrderOptionsClick('FillOrder'),
                    Addingnotes: () => this.DrugOrderOptionsClick('AddNotes'),
                    Settovalid: () => this.DrugOrderOptionsClick('SetToValid'),
                    Viewmedicationhistory: () => this.DrugOrderOptionsClick('ViewMedHistory'),
                    Druginformation: () => this.DrugOrderOptionsClick('DrugInfo'),
                    DrugInteraction: () => this.DrugOrderOptionsClick('DrugInteraction'),
                    Patientinformation: () => this.DrugOrderOptionsClick('PatientInfo'),
                    Returneditems: () => this.DrugOrderOptionsClick('ReturnedItems'),
                    SetToChargeable: () => this.DrugOrderOptionsClick('SetToChargeable'),
                    Settounabletofill: () => this.DrugOrderOptionsClick('SetToUnableToFill'),
                    Undofillorders: () => this.DrugOrderOptionsClick('UndoFillOrders'),
                    UndoSetToChargeable: () => this.DrugOrderOptionsClick('UndoSetToChargeable'),
                    Undovalidated: () => this.DrugOrderOptionsClick('UndoValidated'),
                    DrugInboxAllergies: () => this.DrugOrderOptionsClick('PatientAllergy'),
                    FormularyStatus: () => this.DrugOrderOptionsClick('FormularyStatus'),
                    Printmedlabels: () => this.DrugOrderOptionsClick('PrintMedLabel'),
                    PatientLetters: () => this.GotoLetter().bind(this),
                    ClinicalLetters: () =>
                        this.launchPage(this.$t('Shared.FormGeneration'), 'Clinical-letters', false),
                    PRESCREENING: () =>
                        this.launchPage(this.$t('ENUM.PITEMS.PRESCREENING'), 'prescreening', false),
                    patientLabels: () => this.DoPatientLabelsRepClick(),
                    pSSClinical: () =>
                        this.launchPage(this.$t('ENUM.PITEMS.TResults'), 'testresult', false),
                    appointmentDBpSSClinical: () =>
                        this.launchPage(
                            this.$t('ENUM.PITEMS.TResults'),
                            'appointmentDB-testresult',
                            false
                        ),
                    MarsClinical: () =>
                        this.launchPage(this.$t('ENUM.PITEMS.MarsClinical'), 'MarsClinical', false),
                    appointmentDBVital: () =>
                        this.launchPage(
                            this.$t('Shared.ClinicalVitalSign'),
                            'appointmentDB-vital-sign',
                            false
                        ),
                    appointmentDBSpecialPrecautions: () =>
                        this.launchPage(
                            this.$t('Shared.ClinicalVitalSign'),
                            'appointmentDB-special-precautions',
                            false
                        ),
                    Lab: () =>
                        this.openLabWithToken(
                            LabService.getPatientDemographicsToken(this.$route.params.id),
                            '/ChangeHealthcareGateway/patientDemographics/redirect'
                        ),
                    PPDB_CreateCredentials: () =>
                        this.PatientPortalOptionsClick('CreateCredentials'),
                    //PPDB_CreateAuthLogins: () => this.PatientPortalOptionsClick('CreateAuthLogins'),
                    //PPDB_CreateLogin: () => this.PatientPortalOptionsClick('CreateLogin'),
                    PPDB_ChangeUsername: () => this.PatientPortalOptionsClick('ChangeUsername'),
                    PPDB_ChangePassword: () => this.PatientPortalOptionsClick('ChangePassword'),
                    PPDB_ChangePatInfo: () => this.PatientPortalOptionsClick('ChangePatInfo'),
                    PPDB_Messages: () => this.PatientPortalOptionsClick('Messages'),
                    PPDB_PatientForms: () => this.PatientPortalOptionsClick('PatientForms'),
                    PPDB_PatientInfo: () => this.PatientPortalOptionsClick('PatientInfo'),
                    PPDB_PatientContacts: () => this.PatientPortalOptionsClick('PatientContacts'),
                    PPDB_PatientList: () => this.PatientPortalOptionsClick('PatientList'),
                    PPDB_Summary: () => this.PatientPortalOptionsClick('Summary'),
                    PPDB_PatientClaims: () => this.PatientPortalOptionsClick('PatientClaims'),
                    PPDB_EmailToPatient: () => this.PatientPortalOptionsClick('EmailToPatient'),
                    PPDB_TextToPatient: () => this.PatientPortalOptionsClick('TextToPatient')
                };

                // Execute mapped actions, if exist
                const menuAction = actionsMap[eventName];
                if (menuAction) {
                    menuAction();
                }
            }
            const firstLink = this.$el.querySelector('#rm-items a:first-child');
            if (firstLink) firstLink.classList.add('show-before');
        },

        PatientPortalOptionsClick(action) {
            patientsPortalStore.executeAction = action;
            patientsPortalStore.updatedAt = Date.now();
        },

        DrugOrderOptionsClick(action) {
            drugOrdersStore.executeAction = action;
            drugOrdersStore.updatedAt = Date.now();
        },

        DrugOrdersInboxUpdateStatus(status) {
            // EventBus.$emit('DrugOrdersInboxUpdateStatus', status)
            drugOrdersStore.updateStatus = status;
            drugOrdersStore.updatedAt = Date.now(); // asegura el trigger
        },
        DrugOrdersInboxUpdateChargeable(status) {
            EventBus.$emit('DrugOrdersInboxUpdateChargeable', status);
        },
        DrugOrdersValidation() {
            EventBus.$emit('DrugOrdersValidation');
        },

        DrugOrdersModalMedHistory() {
            EventBus.$emit('DrugOrdersModalOutComeMedHistoryDrugOrderInbox');
        },

        DrugOrderAllergies() {
            EventBus.$emit('DrugOrdersInboxAllergies');
        },

        DrugOrdersSelectAndPush(routeName) {
            EventBus.$emit('DrugOrdersSelectAndPush', routeName);
        },

        DoPatientLabelsRepClick() {
            this.isPatientLabelsRepVisible = true;
        },

        // Helper function to display toast
        showToast(titleKey, msgKey, variant = 'success') {
            this.$bvToast.toast(msgKey, {
                title: titleKey,
                autoHideDelay: 4000,
                variant: variant
            });
        },

        handleError(error) {
            if (!error.response) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.RetrieveInformation'),
                    'error'
                );
            } else {
                this.showMessage(this.$tc('Msg.Error'), error, 'error');
            }
        },

        async GetPermission() {
            if (this.$route.name.includes('appointment')) {
                this.getCheckinsByActivityId();
                this.Appointment = await this.getAppointmentByActId(this.$route.params.actId);
                !this.Appointment.private
                    ? EventBus.$emit('onVisibleApptType', false)
                    : EventBus.$emit('onVisibleApptType', true);
            }
            this.GetItemsListAuthorized();
        },

        openLabWithToken(serviceCall, redirectPath) {
            this.pendingLabAction = { serviceCall, redirectPath };
            this.showLabPasswordDlg = true;
        },

        onLabPasswordResult(result) {
            this.showLabPasswordDlg = false;
            if (result.Event === 'Ok' && result.status === true) {
                const { serviceCall, redirectPath } = this.pendingLabAction;
                serviceCall
                    .then(response => {
                        const token = response.data;
                        const base = ApiService.APIURL.replace(/\/$/, '');
                        window.open(`${base}${redirectPath}?token=${token}`, '_blank');
                    })
                    .catch(error => {
                        const message =
                            error?.response?.data?.errorMessage ||
                            error?.response?.data ||
                            this.$t('Msg.ThereWereSomeError');
                        this.showMessage(this.$t('Msg.Error'), message, 'error');
                    });
            } else if (result.Event !== 'Cancel') {
                this.showMessage(this.$t('Msg.Error'), result.message, 'error');
            }
            this.pendingLabAction = null;
        },

        GotoPatientList() {
            this.$router.push('/app/patients').catch(() => {});
        },

        GotoActivities() {
            this.gotoPage(
                'patient-activities',
                this.$t('Shared.Activity'),
                'appointmentDB-activitiesList',
                true
            );
        },

        OpenAppointmentReason(text) {
            if (text === this.$t('Shared.Cancel')) {
                if (!this.Appointment.private) {
                    EventBus.$emit('onAppointmentReasonModal', text);
                } else {
                    this.showToast(
                        this.$t('MdNotesByAppt.Appointment'),
                        this.$t('Appointments.noCancelMsg')
                    );
                }
            } else {
                this.CancelAppt(text, '');
            }
        },

        GotoGeneralNotes() {
            if (this.$route.params.id != '') {
                this.PatientCode = this.$route.params.id;
            }
            this.$router
                .push({ name: 'patient-generalnotes', params: { id: this.PatientCode } })
                .catch(() => {});
        },

        GotoSchedulerNotes() {
            if (this.$router.currentRoute.name === 'appointmentDB-notes') {
                this.showToast(this.$t('Shared.SchedulerNotes'), this.message);
                return; // Early return
            }
            this.$router
                .push({
                    name: 'appointmentDB-notes',
                    params: { id: this.$route.params.id, actId: this.$route.params.actId }
                })
                .catch(() => {});
        },

        GotoPatientInfo() {
            const { id, recordid, actId } = this.$route.params;

            if (id) {
                this.PatientCode = id;
            } // Assign PatientCode only if id exists

            const pRouteNames = ['patient', 'contact', 'allergy'];
            const cRouteNames = [
                'Clinical',
                'vs',
                'lognote-add',
                'dailynote-add',
                'admission-clinical',
                'clinicalePharmacy',
                'clinical-appoint'
            ];
            // Handle patient-related routes
            if (pRouteNames.some(route => this.$route.name.includes(route))) {
                if (
                    this.$router.currentRoute.name === 'patient-details' ||
                    this.$router.currentRoute.name === 'patient-detailsUAE'
                ) {
                    this.showToast(this.$t('Shared.PatientInfo'), this.message);
                    return; // Early return to prevent further processing
                }
                this.$router.push({ name: 'patient-details', params: { id: this.PatientCode } });
                // this.$store.state.companies.isUAE ? this.$router.push({ name: 'patient-detailsUAE', params: { id: this.PatientCode } }) : this.$router.push({ name: 'patient-details', params: { id: this.PatientCode } });
                return; // Early return
            }
            // Handle clinical-related routes
            if (cRouteNames.some(route => this.$route.name.includes(route))) {
                if (this.$router.currentRoute.name === 'Clinical-PatientInfo') {
                    this.showToast(this.$t('Shared.PatientInfo'), this.message);
                    return; // Early return
                }
                this.$router
                    .push({
                        name: 'Clinical-PatientInfo',
                        params: {
                            id: this.PatientCode,
                            recordid: recordid
                        }
                    })
                    .catch(() => {});
                return; // Early return
            }

            if (this.AppointmentRouteNames.some(route => this.$route.name.includes(route))) {
                if (this.$router.currentRoute.name === 'appointmentDB-PatientInfo') {
                    this.showToast(this.$t('Shared.PatientInfo'), this.message);
                    return;
                }
                this.$router.push({
                    name: 'appointmentDB-PatientInfo',
                    params: {
                        id: this.PatientCode,
                        actId: actId
                    }
                });
                return;
            }
        },

        gotoPage(pageName, titleKey, routeName, v_patient) {
            const { id, actId } = this.$route.params;

            if (id) {
                this.PatientCode = id;
            }

            const currentRouteName = this.$router.currentRoute.name;
            const isAppointmentRoute = this.AppointmentRouteNames.some(route =>
                currentRouteName.includes(route)
            );

            if (isAppointmentRoute) {
                if (currentRouteName === routeName) {
                    this.showToast(titleKey, this.message);
                    return;
                }
                this.$router.push({
                    name: routeName,
                    params: { id: this.PatientCode, actId: actId }
                });
                return;
            } else {
                this.launchPage(titleKey, pageName, v_patient);
            }
        },

        GotoPatientSummary() {
            this.gotoPage(
                'patient-summary',
                this.$t('PatientSummary.PatientDashboard'),
                'patient-summary',
                true
            );
        },
        GotoSchedulerSummary() {
            this.gotoPage(
                'appointmentDB-Dashboard',
                this.$t('schedulerDB.ScheDashboard'),
                'appointmentDB-Dashboard',
                false
            );
        },
        GotoClinicalSummary() {
            this.gotoPage(
                'Clinical-Dashboard',
                this.$t('Clinical.ClinicalDashboard'),
                'Clinical-Dashboard',
                false
            );
        },
        GotoAdmission() {
            this.gotoPage(
                'patient-admissionList',
                this.$t('Admission.Admission'),
                'appointmentDB-admissionList',
                true
            );
        },
        GotoPatientContact() {
            this.gotoPage(
                'patient-contacts',
                this.$tc('Contact.PatientContact', 2),
                'appointmentDB-Ctacts',
                true
            );
        },
        GotoAllergies() {
            this.gotoPage(
                'patient-allergies',
                this.$t('Shared.PatientAllergies'),
                'appointmentDB-allergies',
                true
            );
        },
        GotoSpecialPr() {
            this.gotoPage(
                'patient-special-precautions',
                this.$t('SpecialPrecautions.PatientSpecialPrecautions'),
                'appointmentDB-special-precautions',
                true
            );
        },
        GotoMarsAlerts() {
            this.gotoPage(
                'patient-mars-alerts',
                this.$t('Shared.MarsAlerts'),
                'appointmentDB-mars-alerts',
                true
            );
        },
        GotoPatientAlerts() {
            this.gotoPage(
                'patient-alerts',
                this.$t('Shared.PatientAlerts'),
                'appointmentDB-alerts',
                true
            );
        },
        GotoChartReview() {
            this.gotoPage(
                'patientchartreview',
                this.$t('ChartReview.CHARTREVIEW'),
                'appointmentDB-chartreview',
                true
            );
        },
        GotoAsam() {
            this.gotoPage('patient-asam', this.$t('Shared.ASAM'), 'appointmentDB-asam', true);
        },
        GotoDiagnosis() {
            this.gotoPage(
                'patient-diagnosis',
                this.$t('Shared.Diagnosis'),
                'appointmentDB-diagnosis',
                true
            );
        },
        GotoDocuments() {
            this.gotoPage(
                'patient-document',
                this.$t('employee.Document'),
                'appointments-document',
                true
            );
        },

         GotoNotices() {
            this.gotoPage(
                'patient-notices',
                this.$t('Shared.Notices'),
                'patient-notices',
                true
            );
        },

        GotoInsurances() {
            this.gotoPage(
                'patient-insurance',
                this.$tc('Insurance.Insurance'),
                'appointments-insurance',
                true
            );
        },

        GotoPatientClaim() {
            this.gotoPage(
                'patientclaimList',
                this.$tc('Insurance.Insurance'),
                'patientclaimList',
                true
            );
        },

        GotoVitalSign() {
            this.gotoPage(
                'Clinical-vital-sign',
                this.$t('vitalSignsRep.ReportTitle'),
                'appointmentDB-vital-sign'
            );
        },
        GotoDischarge() {
            this.gotoPage(
                'Clinical-Discharge',
                this.$t('Shared.Discharge'),
                'appointmentDB-discharge'
            );
        },
        GotoPatientDischarges() {
            this.gotoPage(
                'patient-discharges',
                this.$t('Shared.Discharges'),
                'patient-discharges',
                true
            );
        },
        GotoTransfer() {
            this.gotoPage(
                'Clinical-Transfer',
                this.$t('Shared.Transfer'),
                'appointmentDB-transfer'
            );
        },
        GotoePharmacy() {
            this.gotoPage(
                'clinicalePharmacy',
                this.$t('Shared.ePrescribing'),
                'appointmentDB-epharmacy',
                false
            );
        },
        GotoMedications() {
            this.gotoPage(
                'Clinical-Medications',
                this.$t('Medication.Medications'),
                'appointmentDB-Medications',
                true
            );
        },
        GotoApptInsurance() {
            this.gotoPage(
                'patient-contacts',
                this.$tc('Contact.PatientContact', 2),
                'appointments-insurance',
                true
            );
        },
        GotoOrders() {
            this.gotoPage('Clinical-orders', this.$tc('Shared.Orders'), 'appointmentDB-orders');
        },
        GotoTestOrders() {
            this.gotoPage(
                'clinical-test-orders',
                this.$tc('TestOrders.Title'),
                'appointments-test-orders'
            );
        },

        GotoSchedulerDB() {
            this.$router.push('/app/appointments').catch(() => {});
        },

        GotoClinical() {
            this.$router.push('/app/clinical').catch(() => {});
        },

        GotoDrugOrderItemRelocation() {
            this.$router.push('/app/drugorders/items-relocation').catch(() => {});
        },

        GotoDrugOrderItemRemoval() {
            this.$router.push('/app/drugorders/items-removal').catch(() => {});
        },

        GotoLetter() {
            this.gotoPage(
                'patient-letters',
                this.$t('Shared.FormGeneration'),
                'appointmentDB-letter',
                true
            );
        },

        ExecuteShowUp(param, text) {
            AppointmentService.ShowUp(param)
                .then(response => {
                    if (response.status == '200') {
                        this.GetPermission();
                        if (text === this.$t('Shared.uShowUp')) {
                            this.showToast(
                                this.$t('MdNotesByAppt.Appointment'),
                                this.$t('Appointments.uShowUpMsg')
                            );
                        } else {
                            this.showToast(
                                this.$t('MdNotesByAppt.Appointment'),
                                this.$t('Appointments.showUpMsg')
                            );
                        }
                    }
                })
                .catch(error => {
                    this.handleError(error);
                });
        },

        getCheckinsByActivityId() {
            var param = {
                Code: this.$route.params.actId
            };
            ApptCheckinsService.getAll(param)
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.CheckInsAppt = response.data[0];
                    }
                })
                .catch(error => {
                    this.handleError(error);
                });
        },

        ShowUpAppt(text) {
            var param = {
                PatientCode: this.$route.params.id,
                ActivityIdList: this.$route.params.actId,
                Action: text,
                DoctorCode: this.Appointment.therapistcode
            };

            if (text === this.$t('Shared.uShowUp')) {
                param.State = 'F';
                if (
                    this.CheckInsAppt.timeCheckIn === '' ||
                    this.CheckInsAppt.timeCheckIn === null
                ) {
                    this.ExecuteShowUp(param, text);
                } else {
                    this.showToast(
                        this.$t('MdNotesByAppt.Appointment'),
                        this.$t('Appointments.pAlreadyMsg')
                    );
                }
            } else {
                param.State = 'T';
                if (!this.Appointment.reason) {
                    // This checks for "", null, undefined, etc.
                    this.ExecuteShowUp(param, text);
                } else {
                    this.showToast(
                        this.$t('MdNotesByAppt.Appointment'),
                        this.$t('Appointments.aCancelMsg'),
                        'danger'
                    );
                }
            }
        },

        ConfirmAppt(text) {
            var param = {
                ActivityIdList: this.$route.params.actId // must be List
            };

            if (text === this.$t('Shared.uConfirm')) {
                param.IsConfirmed = 'F';
            } else {
                param.IsConfirmed = 'T';
            }

            AppointmentService.ConfirmAppt(param)
                .then(response => {
                    if (response.status == '200') {
                        this.GetPermission();
                        if (text === this.$t('Shared.uConfirm')) {
                            this.showToast(
                                this.$t('MdNotesByAppt.Appointment'),
                                this.$t('Appointments.nConfirmMsg')
                            );
                        } else {
                            this.showToast(
                                this.$t('MdNotesByAppt.Appointment'),
                                this.$t('Appointments.confirmMsg')
                            );
                        }
                    }
                })
                .catch(error => {
                    this.handleError(error);
                });
        },

        CancelAppt(text, reason) {
            var param = {
                ActivityIdList: this.$route.params.actId // must be List
            };
            param.Reason = '';
            if (text === this.$t('Shared.BtnCancel')) {
                param.Reason = reason;
            }

            if (param.ActivityIdList) {
                AppointmentService.CancelAppt(param)
                    .then(response => {
                        if (response.status == '200') {
                            this.GetPermission();
                            if (text === this.$t('Shared.uCancel')) {
                                this.showToast(
                                    this.$t('MdNotesByAppt.Appointment'),
                                    this.$t('Appointments.cancelUnDoneMsg')
                                );
                            } else {
                                this.showToast(
                                    this.$t('MdNotesByAppt.Appointment'),
                                    this.$t('Appointments.cancelMsg')
                                );
                            }
                        }
                    })
                    .catch(error => {
                        this.handleError(error);
                    });
            }
        },

        GotoClaimBatchList() {
            this.$router.push('/app/claimbatch').catch(() => {});
        },

        showAppointment() {
            const { id, actId } = this.$route.params;

            if (id) {
                this.PatientCode = id;
            } // Assign PatientCode only if id exists

            if (this.$router.currentRoute.name === 'appointmentDB-Editor') {
                this.showToast(this.$t('MdNotesByAppt.Appointment'), this.message);
                return;
            }
            this.$router.push({
                name: 'appointmentDB-Editor',
                params: {
                    id: this.PatientCode,
                    actId: actId
                }
            });
            return;
        },

        DrugOrdersExecuteAction(actionName) {
            EventBus.$emit('DrugOrdersExecuteAction', actionName);
        },

        launchPage(v_title, v_name, v_patient) {
            const { id, recordid } = this.$route.params; // Destructure for clarity

            if (id) {
                this.PatientCode = id;
            }

            if (this.$router.currentRoute.name === v_name) {
                // show toast if on the same route
                this.$bvToast.toast(this.message, {
                    title: v_title,
                    autoHideDelay: 4000,
                    variant: 'success'
                });
                return; // Early return
            }
            // Construct params based on v_patient value
            const params = {
                id: this.PatientCode,
                ...(v_patient ? {} : { recordid }) // Include recordid only if v_patient is false
            };
            // Navigate to the new route
            this.$router.push({ name: v_name, params }).catch(() => {});
        },

        GetItemsListAuthorized() {
            this.ItemsListAuthorized = [];
            this.parameter.UserId = LocalStorage.getUserId();

            const addMenuItemConditionally = (element, condition = true, path) => {
                if (condition) {
                    this.addMenuItem(element.text, element.value, path, element.ReadOnly);
                }
            };

            this.ItemList.forEach(element => {
                switch (element.value) {
                    case 'PatientSearch':
                        addMenuItemConditionally(element, true, '/app/patients');
                        break;
                    case 'SchedulerNotes':
                        addMenuItemConditionally(element, this.$store.state.isUseSchedulerClinical);
                        break;
                    case 'ShowUpAppt':
                        element.text = this.Appointment.private
                            ? this.$t('Shared.uShowUp')
                            : this.$t('Shared.ShowUp');
                        addMenuItemConditionally(element);
                        break;
                    case 'CancelAppt':
                        element.text = this.Appointment.reason
                            ? this.$t('Shared.uCancel')
                            : this.$t('Shared.Cancel');
                        addMenuItemConditionally(element);
                        break;
                    case 'ConfirmAppt':
                        element.text = this.Appointment.isConfirmed
                            ? this.$t('Shared.uConfirm')
                            : this.$t('Shared.Confirm');
                        addMenuItemConditionally(element);
                        break;
                    case 'PatientInfo':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientInfo);
                        break;
                    case 'PatientInsurance':
                    case 'InsuranceClinical':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientInsurance);
                        break;
                    case 'PatientDocument':
                    case 'DocumentClinical':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientDocument);
                        break;
                    case 'PatientContact':
                    case 'ContactClinical':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientContact);
                        break;
                    case 'PatientAsam':
                    case 'ClinicalAsam':
                        addMenuItemConditionally(element, this.$store.state.isUseASAM);
                        break;
                    case 'PatientListClinical':
                        addMenuItemConditionally(element, true, '/app/clinical');
                        break;

                    case 'patientclaimList':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUsePatientClaims,
                            '/app/claim'
                        );
                        break;

                    case 'ClinicalNotes':
                        addMenuItemConditionally(element, this.$store.state.isUseClinicalNotes);
                        break;
                    case 'PatientAllergy':
                    case 'AllergyClinical':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientAllergies);
                        break;
                    case 'PatientNotices':
                        addMenuItemConditionally(element, true);
                        break;
                    case 'ClinicalVitalSign':
                        addMenuItemConditionally(element, this.$store.state.isUseVitalSign);
                        break;
                    case 'appointmentDBVital':
                        addMenuItemConditionally(element, this.$store.state.isUseVitalSign);
                        break;
                    case 'Medications':
                        addMenuItemConditionally(element, this.$store.state.isUseMedications);
                        break;
                    case 'Admission':
                    case 'ADMISSIONINFOCLINICAL':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientAdmission);
                        break;
                    case 'CHARTREVIEWCLINICAL':
                    case 'CHARTREVIEWPATIENT':
                        addMenuItemConditionally(element, this.$store.state.isUseChartReview);
                        break;
                    case 'ePharmacyPatient':
                    case 'ePharmacyClinical':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUsepharmacyPatientNewCrop &&
                                this.$store.state.provUseNewCrop
                        );
                        break;
                    case 'DailyNotes':
                        addMenuItemConditionally(element, this.$store.state.isUseDailyNotes);
                        break;
                    case 'LogNotes':
                        addMenuItemConditionally(element, this.$store.state.isUseLogNotes);
                        break;
                    case 'Transfer':
                        addMenuItemConditionally(element, this.$store.state.isUseTransfer);
                        break;
                    case 'PatientDischarges':
                    case 'Discharge':
                        addMenuItemConditionally(element, this.$store.state.isUseDischarge);
                        break;
                    case 'Diagnosis':
                    case 'DiagnosisClinical':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientDiagnosis);
                        break;
                    case 'Lab':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseLab && this.$store.state.provUseLab
                        );
                        break;
                    case 'PatientSummary':
                    case 'SchedulerSummary':
                    case 'ClinicalSummary':
                    case 'AppointmentList':
                    case 'ClaimBatchList':
                        addMenuItemConditionally(element, true);
                        break;

                    case 'PatientInfoClaimBatch':
                    case 'DiagnosisWorksSheet':
                    case 'Doctors':
                    case 'Insurances':
                    case 'incident-report':
                    case 'incident-dashboard':
                    case 'incident-report-general-info':
                    case 'incident-categories':
                    case 'incident-involved':
                    case 'incident-participants':
                        addMenuItemConditionally(element);
                        break;
                    case 'Orders':
                        addMenuItemConditionally(element, this.$store.state.isPhysiciansOrder);
                        break;
                    case 'WYTREATMENTPLAN':
                    case 'MDTREATMENTPLAN':
                    case 'TreatmentPlanClinical':
                    case 'TreatmentPlanScheduler':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseTreatmentPlanClinical
                        );
                        break;
                    case 'SchedulerClinical':
                        addMenuItemConditionally(element, this.$store.state.isUseSchedulerClinical);
                        break;
                    case 'SchedulerPatient':
                        addMenuItemConditionally(element, this.$store.state.isUseSchedulerClinical);
                        break;
                    case 'Appointment':
                    case 'Appointments':
                    case 'ClinicalAppointments':
                    case 'AppointmentInsurance':
                        addMenuItemConditionally(element, this.$store.state.isAppointments);
                        break;
                    case 'PatientSpecialPrecautions':
                    case 'appointmentDBSpecialPrecautions':
                    case 'ClinicalSpecialPrecautions':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientSpecialPr);
                        break;
                    case 'PatientMarsAlerts':
                    case 'ClinicalMarsAlerts':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientMarsAlert);
                        break;
                    case 'PatientAlerts':
                    case 'ClinicalAlerts':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientAlerts);
                        break;
                    case 'PatientActivities':
                    case 'ClinicalActivities':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientActivities);
                        break;
                    case 'Settopending':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxSetToPending
                        );
                        break;
                    case 'Patientlist':
                        addMenuItemConditionally(element);
                        break;
                    case 'Addingnotes':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxPharmacyNotes
                        );
                        break;
                    case 'Settoordered':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxUndoSetToPending
                        );
                        break;
                    case 'Settounabletofill':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxSetToUnableToFill
                        );
                        break;
                    case 'Fillorder':
                        addMenuItemConditionally(element, this.$store.state.isUseDrugInboxFill);
                        break;
                    case 'Undofillorders':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxUndoFillOrder
                        );
                        break;
                    case 'Settovalid':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxSetToValid
                        );
                        break;
                    case 'SetToChargeable':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxSetToChargeable
                        );
                        break;
                    case 'UndoSetToChargeable':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxUndoSetToChargeable
                        );
                        break;
                    case 'Undovalidated':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxUndoValidated
                        );
                        break;
                    case 'Printselectedorder':
                        addMenuItemConditionally(element);
                        break;
                    case 'Returneditems':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxReturnedItems
                        );
                        break;
                    case 'Itemsrelocation':
                        addMenuItemConditionally(element);
                        break;
                    case 'Itemremoval':
                        addMenuItemConditionally(element);
                        break;
                    case 'Printmedlabels':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxPrintMedLabel
                        );
                        break;
                    case 'Patientinformation':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxPatientInfo
                        );
                        break;
                    case 'Prescription':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxPrescription
                        );
                        break;
                    case 'Viewmedicationhistory':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxPrintMedicationHistory
                        );
                        break;
                    case 'Printmedicationhistory':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxPrintMedicationHistory
                        );
                        break;
                    case 'DrugInboxAllergies':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxAllergies
                        );
                        break;
                    case 'FormularyStatus':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isUseDrugInboxFormularyStatus
                        );
                        break;
                    case 'Druginformation':
                        addMenuItemConditionally(element, this.$store.state.isUseDrugInboxDrugInfo);
                        break;
                    case 'DrugInteraction':
                        addMenuItemConditionally(element, this.$store.state.isUseDrugInboxInteraction);
                        break;
                    /*case 'Druginteractions':
                        addMenuItemConditionally(element);
                        break;*/
                    case 'PatientLetters':
                    case 'ClinicalLetters':
                        addMenuItemConditionally(element, this.$store.state.isUseLetters);
                        break;
                    case 'PRESCREENING':
                        addMenuItemConditionally(element, this.$store.state.isUsePreScreening);
                        break;
                    case 'patientLabels':
                        addMenuItemConditionally(element, this.$store.state.isUsePatientLabels);
                        break;
                    case 'pSSClinical':
                        var isValid =
                            this.$store.state.isUseTestResult && this.$store.state.companies.isNRC;
                        addMenuItemConditionally(element, isValid);
                        break;
                    case 'appointmentDBpSSClinical':
                        var appointmentDBisValid =
                            this.$store.state.isUseTestResult && this.$store.state.companies.isNRC;
                        addMenuItemConditionally(element, appointmentDBisValid);
                        break;
                    case 'MarsClinical':
                        addMenuItemConditionally(element, this.$store.state.isUseMars);
                        break;
                    case 'TestOrders':
                        addMenuItemConditionally(element, this.$store.state.isTestOrders);
                        break;
                    case 'PPDB_CreateCredentials':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isPatientPortalCreateCredentials
                        );
                        break;
                    case 'PPDB_ChangeUsername':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isPatientPortalChangeUsername
                        );
                        break;
                    case 'PPDB_ChangePassword':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isPatientPortalChangePassword
                        );
                        break;
                    case 'PPDB_ChangePatInfo':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isPatientPortalChangeInformation
                        );
                        break;
                    case 'PPDB_Messages':
                        addMenuItemConditionally(element, this.$store.state.isPatientPortalMessage);
                        break;
                    case 'PPDB_PatientForms':
                        addMenuItemConditionally(element, this.$store.state.isPatientPortalForms);
                        break;
                    case 'PPDB_PatientInfo':
                    case 'PPDB_PatientList':
                    case 'PPDB_Summary':
                        addMenuItemConditionally(element);
                        break;
                    case 'PPDB_PatientContacts':
                        addMenuItemConditionally(
                            element,
                            this.$store.state.isPatientPortalContacts
                        );
                        break;
                    case 'PPDB_PatientClaims':
                        addMenuItemConditionally(element, this.$store.state.isPatientPortalClaims);
                        break;

                    case 'PPDB_EmailToPatient':
                        addMenuItemConditionally(element, this.$store.state.isPatientPortalEmailTo);
                        break;
                    case 'PPDB_TextToPatient':
                        addMenuItemConditionally(element, this.$store.state.isPatientPortalTextTo);
                        break;
                    default:
                        break;
                }
            });

            if (this.ItemsListAuthorized.length > 2) {
                const sorted = this.ItemsListAuthorized.filter((v, index) =>
                    !this.SortAllOptions ? index > 1 : index >= 0
                ).sort((a, b) => {
                    const x = a.text.toLowerCase();
                    const y = b.text.toLowerCase();
                    return x < y ? -1 : x > y ? 1 : 0;
                });

                this.ItemsListAuthorized = !this.SortAllOptions
                    ? [this.ItemsListAuthorized[0], this.ItemsListAuthorized[1], ...sorted]
                    : [...sorted];
            }
        },

        addMenuItem(text, value, href, ReadOnly) {
            const item = { text, value, href, ReadOnly, children: [], isOpen: false };
            this.ItemsListAuthorized.push(item);
        },

        hasNotification(id) {
            // Mapea IDs del menú con las propiedades de `status`
            const statusMap = {
                AllergyClinical: 'hasAllergies',
                PatientAllergy: 'hasAllergies',

                ClinicalAlerts: 'hasAlerts',
                PatientAlerts: 'hasAlerts',

                ClinicalSpecialPrecautions: 'hasSpecialPrecautions',
                PatientSpecialPrecautions: 'hasSpecialPrecautions'
            };
            return this.status[statusMap[id]] || false;
        },

        loadPatientRemarkst(code) {
            if (code) {
                PatientService.getPatientRemarks(code)
                    .then(response => {
                        if (response.status == '200') {
                            var remarks = response.data;
                            this.status = {
                                hasAllergies: remarks.hasAllergies,
                                hasAlerts: remarks.hasAlerts,
                                hasSpecialPrecautions: remarks.hasSpecialPrecautions
                            };
                        }
                    })
                    .catch(error => {
                        this.handleError(error);
                    });
            }
        }
    },

    computed: {
        active_element() {
            return this.$attrs.active_el && this.$attrs.active_el !== ''
                ? this.$attrs.active_el
                : this.active_el;
        },

        filteredItems() {
            const query = (this.searchOptModel || '').toLowerCase().trim();
            if (!query) return this.ItemsListAuthorized;

            return this.ItemsListAuthorized.reduce((acc, item) => {
                const parentMatches = item.text && item.text.toLowerCase().includes(query);
                if (parentMatches) {
                    acc.push(item);
                    return acc;
                }
                if (item.children && item.children.length) {
                    const matchingChildren = item.children.filter(
                        c => c.text && c.text.toLowerCase().includes(query)
                    );
                    if (matchingChildren.length) {
                        acc.push({ ...item, children: matchingChildren, isOpen: true });
                    }
                }
                return acc;
            }, []);
        }
    },

    created() {
        EventBus.$on(
            'onSelectAppointmentReason',
            function(param) {
                this.CancelAppt(param.Text, param.Reason);
            }.bind(this)
        );

        // Kept as bound refs so destroyed() can remove only this instance's
        // listener - EventBus.$off(event) with no handler wipes out every
        // listener for that event, including ones from other still-mounted
        // Item instances (each right-bar variant embeds its own Item).
        this.onSearchOptHandler = function(value) {
            this.searchOptModel = value;
        }.bind(this);
        EventBus.$on('onSearchOpt', this.onSearchOptHandler);

        this.onResetItemActiveElHandler = function() {
            this.active_el = '';
        }.bind(this);
        EventBus.$on('ResetItemActiveEl', this.onResetItemActiveElHandler);
    },

    updated() {
        this.itemdisabled = this.$attrs.itemdisabled;
        this.PatientCode = this.$attrs.PatientCode;
    },

    beforeCreate() {
        this.itemdisabled = this.$attrs.itemdisabled;
        this.PatientCode = this.$attrs.PatientCode;
    },

    watch: {
        ItemList: {
            immediate: true,
            deep: true,
            handler() {
                this.GetItemsListAuthorized();
            }
        }
    },

    mounted() {
        this.itemdisabled = this.$attrs.itemdisabled;
        this.PatientCode = this.$attrs.PatientCode;

        if (this.$attrs.active_el) {
            this.active_el = this.$attrs.active_el;
        }

        this.GetPermission();
        this.loadPatientRemarkst(this.$route.params.id);

        if (this.$route.name === 'patient-summary') {
            this.active_el = 'PatientSummary';
        } else if (this.$route.name === 'Clinical-Dashboard') {
            this.active_el = 'ClinicalSummary';
        } else if (this.$route.name === 'appointmentDB-Dashboard') {
            this.active_el = 'SchedulerSummary';
        }

        document.addEventListener('DOMContentLoaded', () => {
            const firstLink = document.querySelector('.rm-options #rm-items a:first-child');
            if (firstLink) {
                firstLink.classList.add('show-before');
            }
        });
    },
    destroyed() {
        EventBus.$off('onSearchOpt', this.onSearchOptHandler);
        EventBus.$off('ResetItemActiveEl', this.onResetItemActiveElHandler);
    }
};
</script>

<style>
/*.isDisabled {
  cursor: not-allowed!important;
  pointer-events: none;
  opacity: 0.5!important;
}
.isDisabled > a {
  color: currentColor!important;
  display: inline-block!important;  /* For IE11/ MS Edge bug
  pointer-events: none!important;
  text-decoration: none!important;
}*/

a.isDisabled {
    position: relative; /* necesario */
    cursor: not-allowed;
    opacity: 0.6;
}

/* capa invisible que bloquea el click */
a.isDisabled::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
}

.rmActiveItem {
    background-position: -230px !important;
    color: #fff !important;
}

.rm-subitems {
    display: flex;
    flex-direction: column;
}

.rm-subitem {
    padding-left: 24px !important;
    font-size: 0.9em;
    cursor: pointer;
}
</style>
